import { parseCreativeIdDigest } from 'hooks';
import type { ReuploadCreativeRef, ReuploadCreativeType } from 'features/creatives';
import type { CreativeEntry } from 'types/shared';

const SUPPORTED_TYPES: readonly ReuploadCreativeType[] = ['image', 'video'];

const toReuploadType = (value: string): ReuploadCreativeType | null => {
  const normalized = value.toLowerCase();
  return (SUPPORTED_TYPES as readonly string[]).includes(normalized) ? (normalized as ReuploadCreativeType) : null;
};

/** X accepts image and video only; html and other types cannot be reuploaded. */
export const isReuploadableCreative = (row: CreativeEntry): boolean => toReuploadType(row.creative_type) !== null;

/** `null` when the type is unsupported or the row id has no numeric pk. */
export const toReuploadCreativeRef = (row: CreativeEntry): ReuploadCreativeRef | null => {
  const type = toReuploadType(row.creative_type);
  const id = Number(parseCreativeIdDigest(row.id) ?? row.id);
  if (type === null || !Number.isInteger(id)) return null;

  return { id, creative_type: type };
};

export const toReuploadCreativeRefs = (rows: readonly CreativeEntry[]): ReuploadCreativeRef[] =>
  rows.map(toReuploadCreativeRef).filter((ref): ref is ReuploadCreativeRef => ref !== null);
